import { render, staticRenderFns } from "./BrowseTable.vue?vue&type=template&id=0b64ce72&scoped=true&"
import script from "./BrowseTable.vue?vue&type=script&lang=js&"
export * from "./BrowseTable.vue?vue&type=script&lang=js&"
import style0 from "./BrowseTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrowseTable.vue?vue&type=style&index=1&id=0b64ce72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64ce72",
  null
  
)

export default component.exports